// Ceci rend les menus visibles lorsqu'on clique sur leur titre
document.querySelectorAll('.footer_menu span.h6').forEach(menu => {
  menu.addEventListener('click', () => {
    const toggleContent = menu.nextElementSibling;
    toggleContent.classList.toggle('active'); // Ajoute/enlève la classe 'active'
  });
});
// Trouve tous les titres du texte du footer
document.querySelectorAll('.footer_content span.h6').forEach(title => {
  // Ajoute une action quand on clique sur le titre
  title.addEventListener('click', () => {
    // Trouve le texte caché sous le titre
    const toggleContent = title.nextElementSibling;
    // Montre ou cache le texte en ajoutant/enlevant 'active'
    toggleContent.classList.toggle('active');
  });
});
